// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AboutController from './about_controller'
application.register('about', AboutController)

import CalculatorController from './calculator_controller'
application.register('calculator', CalculatorController)

import ColorModeController from './color_mode_controller'
application.register('color-mode', ColorModeController)

import PopoverController from './popover_controller'
application.register('popover', PopoverController)

import GalleryController from './gallery_controller'
application.register('gallery', GalleryController)

import SignatureController from './signature_controller'
application.register('signature', SignatureController)

import EventRegFormController from './event_reg_form_controller'
application.register('event-reg-form', EventRegFormController)
